module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-218.8ec478e1.svg";